import getCurrentTrimmedLocale from '../../utils/getCurrentTrimmedLocale';

export class EnvConfig {
  constructor() {
    this.env = process.env;
  }

  getMothershipBaseUrl() {
    return this.env.REACT_APP_MOTHERSHIP_BASE_URL;
  }

  getTermsOfServiceUrl() {
    const locale = getCurrentTrimmedLocale() === 'fi' ? 'fi' : 'en';
    return `${this.env.REACT_APP_WEBSITE_BASE_URL}/terms?lang=${locale}`;
  }

  getPrivacyPolicyUrl() {
    const locale = getCurrentTrimmedLocale() === 'fi' ? 'fi' : 'en';
    return `${this.env.REACT_APP_WEBSITE_BASE_URL}/privacy-policy?lang=${locale}`;
  }

  getAnalyticsEndpointUrl() {
    return this.env.REACT_APP_ANALYTICS_ENDPOINT;
  }

  getGoogleTrackingId() {
    return this.env.REACT_APP_GOOGLE_TRACKING_ID;
  }

  isProdEnv() {
    const envCode = this.env.REACT_APP_ENV_CODE || '';
    return envCode.toUpperCase() === 'X';
  }
}

export default new EnvConfig();
